type Filling<C, K extends string, Empty> = [Extract<C[keyof C], { readonly [P in K]: unknown }>] extends [never]
  ? Empty
  : Extract<C[keyof C], { readonly [P in K]: unknown }>;

export function filling<C extends object, K extends string, Empty>(catalog: C, slot: K): [string, Filling<C, K, Empty>][] {
  const fills = (entry: unknown): entry is Filling<C, K, Empty> => typeof entry === "object" && entry !== null && slot in entry;
  type Named = [string, Filling<C, K, Empty>];
  return Object.entries(catalog).flatMap(([name, entry]: [string, unknown]): Named[] => (fills(entry) ? [[name, entry]] : []));
}
